export enum ComponentSource {
  HotelViewRoomsSection = 'hotelViewRoomsSection',
  RoomSelection = 'roomSelection',
  SearchViewTopOffers = 'searchViewTopOffers',
  HotelViewTopOffers = 'hotelViewTopOffers'
}
